<template>
  <div
    class="home-hero-video"
    data-video
  >
    <div
      class="home-hero-popup"
      ref="popup"
      @click="hidePopup"
      @keydown.esc="hidePopup"
      tabindex="0"
      title="Close (Esc)"
    >
      <div class="home-hero-popup__inner">
        <div
          class="home-hero-popup__close"
          title="Close (Esc)"
        >×</div>
        <div class="responsive-embed widescreen">
          <iframe
            src="https://player.vimeo.com/video/923172195"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
    <div
      class="home-hero-video-wrapper"
      data-aos="fade-left"
      data-aos-duration="1000"
      data-aos-offset="400"
    >
      <div class="home-hero-video-placeholder">
        <img src="../../assets/home-video-placeholder.png" />
      </div>
      <div class="home-hero-video-overlay">
        <a
          href="#"
          class="home-hero-video-overlay__play-button"
          @click.prevent="showPopup"
        >
          <FontAwesomeIcon icon="play" />
        </a>
      </div>
    </div>
    <div
      class="home-hero-video-subtext"
      data-aos="fade-right"
      data-aos-duration="1000"
      data-aos-offset="100"
    >
      Everything we do is centered around protecting our doctors.
    </div>
  </div>
</template>

<script>
import Player from '@vimeo/player';

export default {
  name: 'HomeHeroVideo',
  data () {
    return {
      player: null
    };
  },
  mounted () {
    const iframe = $(this.$refs.popup).find('iframe');
    this.player = new Player(iframe);
  },
  methods: {
    showPopup () {
      const $popup = $(this.$refs.popup);
      $('#nav').removeClass('up');
      $popup.css('z-index', 5);
      $('html').css('overflow', 'hidden');
      $popup.animate(
        { opacity: 1 },
        600,
        () => {
          this.player.play();
          this.$refs.popup.focus();
        }
      );
    },
    hidePopup () {
      const $popup = $(this.$refs.popup);
      this.player.pause();
      $popup.animate(
        { opacity: 0 },
        600,
        () => {
          $popup.css('z-index', -1);
          $('html').css('overflow', '');
        }
      );
    }
  }
};
</script>
